'use client';

import { useContext, useMemo } from 'react';
import { ToastContext } from '@/contexts/ToastContext';

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');

  return useMemo(
    () => ({
      success: (msg: string) => ctx.addToast('success', msg),
      error: (msg: string) => ctx.addToast('error', msg),
      warning: (msg: string) => ctx.addToast('warning', msg),
      info: (msg: string) => ctx.addToast('info', msg),
    }),
    [ctx]
  );
}
